// The card's header, as in Isomorphic's multi-step form (FormSummary): the step's title, "Step
// X of N" and what to do, over a segmented progress bar.
import { cn } from "../../../ui/cn";

export function StepHeader({ title, description, step, total, counter }: { title: string; description: string; step: number; total: number; counter: string }) {
  return (
    <header className="mb-6 md:mb-8">
      <div className="mb-4 flex gap-1.5" aria-hidden>
        {Array.from({ length: total }, (_, i) => (
          <span key={i} className={cn("h-1.5 flex-1 rounded-full", i <= step ? "bg-primary" : "bg-gray-200")} />
        ))}
      </div>
      <div className="flex flex-wrap-reverse items-baseline justify-between gap-x-5 gap-y-1">
        <h2 className="text-lg font-semibold text-gray-900 md:text-xl">{title}</h2>
        <span className="text-[13px] font-medium text-gray-500">{counter}</span>
      </div>
      <p className="mb-0 mt-1.5 text-[13.5px] leading-relaxed text-gray-500">{description}</p>
    </header>
  );
}
